<template>
  <div class="admin-header">
    <div class="left">
      <span class="system-title">驾考学习系统后台管理</span>
    </div>

    <div class="right">
      <span class="user-info">
        <i class="el-icon-user"></i> {{ userInfo ? userInfo.username : '-' }}
        <template v-if="userInfo && userInfo.realName">
          <el-divider direction="vertical"></el-divider>
          {{ userInfo.realName }}
        </template>
      </span>

      <!-- 新增：暗黑模式切换按钮 -->
      <el-button
          type="text"
          class="dark-mode-btn"
          @click="toggleDarkMode"
          :title="$store.state.isDarkMode ? '切换亮色模式' : '切换夜间模式'"
      >
        <i :class="$store.state.isDarkMode ? 'el-icon-sunny' : 'el-icon-moon'"></i>
      </el-button>

      <el-button
          type="text"
          class="switch-mobile-btn"
          @click="switchToMobile"
      >
        切换到手机端
      </el-button>

      <el-button
          type="text"
          class="logout-btn"
          @click="handleLogout"
      >
        退出登录
      </el-button>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api/auth'
import { removeToken } from '@/utils/auth'
import { setClientType, getHomePathByRole } from '@/utils/device'

export default {
  name: 'AdminHeader',

  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },

  methods: {
    // 新增：切换夜间模式方法
    toggleDarkMode() {
      this.$store.commit('TOGGLE_DARK_MODE')
    },

    switchToMobile() {
      setClientType('mobile')

      const user = this.$store.state.userInfo || {}
      const targetPath = getHomePathByRole(user.role, 'mobile')

      this.$router.replace(targetPath)
    },

    async handleLogout() {
      try {
        const res = await logout()
        if (res.code === 200) {
          this.$message.success('退出成功')
        }
      } catch (e) {
        console.log('退出接口异常', e)
      } finally {
        removeToken()
        this.$store.commit('CLEAR_USER_INFO')
        this.$router.replace('/login')
      }
    }
  }
}
</script>

<style scoped>
.admin-header {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.system-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-info,
.role-info {
  color: #606266;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.user-info i {
  margin-right: 4px;
}

/* 新增：暗黑模式按钮样式 */
.dark-mode-btn {
  font-size: 18px;
  color: #606266 !important;
  padding: 0 5px;
}

.dark-mode-btn:hover {
  color: #409EFF !important;
}

.switch-mobile-btn {
  color: #409EFF !important;
  font-weight: 500;
}

.switch-mobile-btn:hover {
  color: #66b1ff !important;
  text-decoration: underline;
}

.logout-btn {
  color: #f56c6c !important;
  font-weight: 500;
}

.logout-btn:hover {
  color: #f78989 !important;
  text-decoration: underline;
}
</style>